const SvgIconWarning = (props) => {
  const {
    width = "1.5rem",
    height = "1.5rem",
    enableViewBox = true,
    iconFillColor = "fill-[#FFFAEB]",
    outerFillColor = "fill-[#CAA416]",
    ...otherProps
  } = props;
  return (
    <svg
      width={width}
      height={height}
      {...(enableViewBox && { viewBox: `0 0 ${width} ${height}` })}
      {...otherProps}
    >
      <g fill="none" fillRule="evenodd">
        <g className={outerFillColor} fillRule="nonzero">
          <g>
            <path
              d="M21.998 22.583c1.536 0 2.501-1.666 1.732-3L13.732 2.25c-.768-1.33-2.695-1.333-3.464 0L.27 19.584c-.768 1.33.193 3 1.732 3h19.996zM13.01 15.25H10.99c-.266 0-.485-.208-.5-.473l-.309-5.666c-.015-.287.213-.528.5-.528h2.64c.287 0 .515.241.5.528l-.31 5.666c-.014.265-.233.473-.499.473zM12 19.833c-1.059 0-1.917-.858-1.917-1.916 0-1.059.858-1.917 1.917-1.917 1.059 0 1.917.858 1.917 1.917 0 1.058-.858 1.916-1.917 1.916z"
            // fill={iconFillColor}
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default SvgIconWarning;
